import { useEffect, useState } from 'react';
import { IcebergButton } from '@tradesolution/iceberg-ui-react';
import useIsMountedRef from 'utils/hooks/useIsMountedRef';
import Style from './index.module.css';

export interface SortOption {
  label: string;
  value: string;
  icon: 'edit' | 'plus' | 'alert';
  color: 'primary' | 'success' | 'warning';
  active: boolean;
}

interface Props {
  options: SortOption[];
  onChange: (toggled: string[]) => void;
  tags: string[];
}

const ToggleSortByTag = (props: Props) => {
  const [toggledValues, setToggledValues] = useState<string[]>([]);

  const isMountedRef = useIsMountedRef();

  useEffect(() => {
    if (isMountedRef.current) {
      props.onChange(toggledValues);
    }
  }, [toggledValues, isMountedRef]);

  const getIcon = (option: SortOption) => {
    switch (option.value) {
      case 'relatedToLopenr':
        return 'check';
      case 'newEnhet':
        return 'plus';
      case 'hasNedlagtDato':
        return 'alert';
      case 'hasUtmeldtDato':
        return 'alert';
      case 'hasInnmeldtDato':
        return 'plus';
      default:
        return 'circle-empty';
    }
  };

  const getVariant = (option: SortOption) => {
    switch (option.color) {
      case 'warning':
        return option.active ? 'warning' : 'outline-warning';
      case 'success':
        return option.active ? 'success' : 'outline-success';
      default:
        return option.active ? 'primary' : 'outline-primary';
    }
  };

  const toggleFilter = (option: SortOption) => {
    option.active = !option.active;

    const copy = [...toggledValues];
    if (copy.filter((x) => x === option.value).length > 0) {
      const filtered = copy.filter((y) => y !== option.value);
      setToggledValues([...filtered]);
    } else {
      setToggledValues([...toggledValues, option.value]);
    }
  };

  return (
    <div className={Style.sortByTagContainer}>
      {props.options?.map((option, idx) => (
        <IcebergButton
          className={Style.customToggleBtn}
          icon={getIcon(option)}
          key={idx}
          size="sm"
          variant={getVariant(option)}
          name="custom-toggle-button"
          value={option.value}
          onClick={() => toggleFilter(option)}
        >
          {option.label}
        </IcebergButton>
      ))}
    </div>
  );
};

export default ToggleSortByTag;
